import { createContext } from "react";
import { ThemeOverrideWrapper } from "./themes";

export const ThemeContext = createContext<ThemeOverrideWrapper>({});
